<script>
	import listBase from '@_system/components/base/list.vue'
	import policyTree from './policytree/index.vue'
	import transfergoodsBox from './box/transfergoods.vue'
	import {adminMixin} from './project/admin/mixin.js'
	import {liutiMixin} from './project/liuti/mixin.js'
	
	let mixin = window.config.company === 'liuti'
		? liutiMixin 
		: adminMixin
		
	export default {
		extends: listBase,
		mixins:[mixin],
		name: 'purchaseIndex',
		props: {

		},
		render(h) {
			this.$slots.mainheader = [
				<el-row>
					<el-button size="mini" type="success" onClick={this.exportSuggest}>导出建议</el-button>
					<el-button size="mini" type="danger" onClick={this.reflash}>清除缓存</el-button>
				</el-row>
			]
			this.$slots.aside = [
				<policy-tree ref="policyTree" key={this.policyTree} onSelect={this.policyTreeChange} />
			]
			this.$slots.header = [
				<el-breadcrumb separator-class="el-icon-arrow-right" >
					{
						this.parentbread.length!=0?this.parentbread.map((item,index)=>{
						return <el-breadcrumb-item key={index}>{item.name}</el-breadcrumb-item>
					}):<el-breadcrumb-item>请选择采购策略</el-breadcrumb-item>
					
					}			
				</el-breadcrumb>
			]
			this.$slots.plug = [
				this.customerloading?<div class="full" v-loading={true} element-loading-text={this.loadingtext}></div>:'',
				<transfergoods-box ref="transfergoodsBox" data={this.transfergoodsBoxData} onSubmit={this.transfergoodsBoxSubmit} />
			]
			return listBase.render.call(this, h)
		},		
		data() {
			return {
				customerloading:false,
				loadingtext:'正在生成采购建议，请稍后...',
				moduleName: 'purchase',
				windowName: '采购建议',
				policyTree:Math.random(),
				parentbread:[],
				currentPolicy:null,
				projectHandle:null,
				transfergoodsBoxData:[]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

			
		},
		computed: {

		},
		methods: {

		},
		components: {
			policyTree,
			transfergoodsBox
		}
	}
</script>
